import { Text } from '@harperai/materialize-design-system';
import './style/Action.css';
import React from 'react';

const Action = ({ reference, onClick, label, negative = false }) => {
    return (
        <div ref={reference} className={`keystone-action ${negative ? "negative" : ""} pad-s`} onClick={onClick}>
            <Text header={4} size="paragraph" bold={true}>{label}</Text>
        </div>
    );
};

export default React.memo(Action);